// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2U79a","content":"ManualTimeModal_content__2R7-0"};